import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updatePreApprovalLoan } from "../pre-approval-loan-wrapper/actions";
import FinancingCfExpired from "./component";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({updatePreAppovalLoanConnect: updatePreApprovalLoan}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FinancingCfExpired);
